<sim-basic-app-page-layout
	[backUrl]="backUrl"
	[hasError]="loadingConfig?.hasError"
	[isLoading]="loadingConfig?.isLoading"
	[headerIcon]="headerIcon.fontIcon"
	[headerLabel]="headerToken"
>
	<ng-container headerActions>
		<ng-content select="[headerActions]" />
	</ng-container>

	<ng-container body>
		<div class="gridLayout">
			<div class="tableWrapper">
				<ng-content select="[table]" />
			</div>
			<ng-container *ngTemplateOutlet="paginator" />
		</div>
	</ng-container>

	<ng-container actions>
		<ng-content select="[actions]" />
	</ng-container>
</sim-basic-app-page-layout>

<!-- required workaround for content projection with the same select=[attr] -->
<ng-template #paginator>
	<div class="matPaginatorContainer">
		<ng-content select="[paginatorContainer]" />
	</div>
</ng-template>
